import { DatePipe } from '@angular/common';
import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslationService } from '../services/translation.service';

@Pipe({
  name: 'formatDate',
})
export class FormatDatePipe implements PipeTransform {
  readonly #translationService = inject(TranslationService);

  // input: YYYYMMDD => output: DD.MM.YYYY or DD-MM-YYYY or ...
  // input: YYYYMM => output: MM.YYYY or MM-YYYY or ... (without day part)
  // Example: '20240215' | formatDate:'shortDate' => '15.02.2024'
  // Example: '202402' | formatDate => '02/2024' (locale-specific month/year)
  // Example: '202402' | formatDate:'MMMM yyyy' => 'February 2024'
  transform(value: string | undefined, format?: string): string {
    if (!value || (value.length !== 8 && value.length !== 6)) {
      return '';
    }
    const year = value.substring(0, 4);
    const month = value.substring(4, 6);

    if (value.length === 6) {
      // YYYYMM format - use first day of month for date parsing
      // Default to 'yyyy/MM' format if no format specified
      const monthFormat = format || 'yyyy/MM';
      const pipe = new DatePipe(this.#translationService.getLanguage()());
      return pipe.transform(new Date(`${year}-${month}-01`), monthFormat) || '';
    }

    // YYYYMMDD format - default to 'shortDate' if no format specified
    const dateFormat = format || 'shortDate';
    const day = value.substring(6, 8);
    const pipe = new DatePipe(this.#translationService.getLanguage()());
    return pipe.transform(new Date(`${year}-${month}-${day}`), dateFormat) || '';
  }
}
